<div class="nav-left">
  <div *ngFor="let tab of tabs"
       class="nav-item"
       [ngClass]="{'selected' : isSelected(tab)}"
       [routerLink]="tab.routerLink">

    <div class="icon-box">
       <i class="{{tab.icon}}"></i>
    </div>
    {{ tab.label }}
  </div>
</div>

<div class="nav-right">
  <yo-button
    *ngIf="isOnInventaire()"
    iconClass="fas fa-compress-alt"
    [theme]="ButtonThemeEnum.SECONDARY_INNER"
    tooltip="Réduire tous les éléments du tableau"
    (onClick)="collapseAccordion()">
  </yo-button>

  <yo-button
    *ngIf="isOnInventaire()"
    iconClass="fas fa-expand-alt"
    [theme]="ButtonThemeEnum.SECONDARY_INNER"
    tooltip="Étendre tous les éléments du tableau"
    (onClick)="expendAccordion()">
  </yo-button>

  <yo-button
    *ngIf="isOnHistoriqueInventaire()"
    iconClass="fas fa-file-excel"
    [theme]="ButtonThemeEnum.SECONDARY_INNER"
    tooltip="Exporter Excel"
    (onClick)="stockSvc.announceExportHistorique()">
  </yo-button>

  <yo-button *ngIf="isPrintable()"
             iconClass="fas fa-print"
             [theme]="ButtonThemeEnum.SECONDARY_INNER"
             (onClick)="stockSvc.announceClickPrint()"
             tooltip="Extraction des données">
  </yo-button>
</div>
